"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PageOneForcedContent;
var _react = _interopRequireWildcard(require("react"));
var _Notebook = _interopRequireDefault(require("../svg/Notebook"));
var _GLWBModals = require("../GLWBModals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function PageOneForcedContent() {
  var [stepUpModalOpen, setStepUpModalOpen] = (0, _react.useState)(false);
  var stepUpModalClose = () => {
    setStepUpModalOpen(false);
  };
  var [retirePayModalOpen, setRetirePayModalOpen] = (0, _react.useState)(false);
  var retirePayModalHandleClose = () => {
    setRetirePayModalOpen(false);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "glwb-side-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement(_Notebook.default, {
    className: "align-top"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "inline-block rig-sideContent-title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sideContent-smallTitle"
  }, "LEARN MORE ABOUT RETIREPAY"), /*#__PURE__*/_react.default.createElement("h4", {
    className: "margin-top-0 mm-spacing--minor"
  }, "Good to know"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, "This calculator compares the income produced by two Guaranteed Lifetime Withdrawal Benefit (GLWB) riders: RetirePay, available with MassMutual Envision, which has the roll-up built into the withdrawal rate, and a GLWB with a traditional roll-up on the benefit base amount. ", /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h4", null, "Key Resources")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    href: "https://fieldnet.massmutual.com/public/ann/pdfs/an2701.pdf",
    target: "_blank",
    rel: "noreferrer"
  }, "Learn more about MassMutual Envision with RetirePay\xA0", /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-sm icon-external-link"
  })))), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    target: "_self",
    href: "#",
    onClick: () => setStepUpModalOpen(true),
    "data-bp-link": "default"
  }, "Understanding How Step-ups Impact the RetirePay Benefit Base"), /*#__PURE__*/_react.default.createElement(_GLWBModals.GLWBStepUpModal, {
    handleClose: () => stepUpModalClose(),
    show: stepUpModalOpen
  })), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("a", {
    target: "_self",
    href: "#",
    onClick: () => setRetirePayModalOpen(true),
    "data-bp-link": "default"
  }, "The RetirePay Difference"), /*#__PURE__*/_react.default.createElement(_GLWBModals.GLWBRetirePayModal, {
    handleClose: () => retirePayModalHandleClose(),
    show: retirePayModalOpen
  })), /*#__PURE__*/_react.default.createElement("p", null))));
}